import * as _ from "lodash";

export class DataRecord {
    public id: any = null;
    public uid: any = null;
    public version: any = null;
    public datarecordlink: any = null;
    public timestamp: any = null;
    public ethnicity = "0";
    public religion = "0";
    public politicalopinion = "0";
    public tradeunionmembership = "0";
    public geneticdata = "0";
    public biometricdata = "0";
    public healthinformation = "0";
    public gender = "0";

    constructor(data?: any) {
        this.setData(data);
    }

    setData(data: any): void {
        if (data && data.attributes) {
            data.attributes.id = data.id;
            _.merge(this, data.attributes);
        } else {
            _.merge(this, data);
        }
    }
}
